import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import SearchBar from "../../common/SearchBar"

import KeyIssueListContainer from "./KeyIssueListContainer"

const KeyIssueListWidget = ({
    onFilterSelect,
    canAdd,
    isFetching,
    invalidate,
    pagingRequest,
    nameSearchTerm,
    isEmptySearchValue,
    onSearch,
    onAdd
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={canAdd}
            iconComponent={<span className="icon icon-insights" />}
            listTitle="Key issues"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
            onFilterSelect={onFilterSelect(pagingRequest)}
        />
        <div className="quick-filters">
            <SearchBar searchTerm={nameSearchTerm} onSearch={onSearch} />
            <div className="form-check">
                <label className="form-check-label">
                    <input
                        className="form-check-input"
                        name="empty"
                        type="checkbox"
                        checked={isEmptySearchValue}
                        onChange={onSearch}
                    />&nbsp; Only key issues without mappings
                </label>
            </div>
        </div>
        <KeyIssueListContainer />
    </div>
)

export default KeyIssueListWidget
